export function isEmptyLineItem(lineItem) {
  return !(lineItem.product?.sku && lineItem.quantity)
}

export function rejectEmptyLineItems(lineItems) {
  return lineItems?.filter(lineItem => !isEmptyLineItem(lineItem))
}
